import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'components/ui/index';

const ModalButton = ({
  modalTitle,
  modalProps,
  children: Children,
  modalSize,
  buttonLabel,
  trigger: Trigger,
  ...restProps
}) => {
  const [showModal, toggleShowModal] = useState(false);

  return (
    <React.Fragment>
      <Trigger
        {...restProps}
        onClick={() => {
          toggleShowModal(!showModal);
        }}
      >
        {buttonLabel}
      </Trigger>
      <Modal
        isOpen={showModal}
        title={modalTitle}
        size={modalSize}
        {...modalProps}
        toggle={() => {
          return toggleShowModal(!showModal);
        }}
      >
        <Children
          closeModal={() => {
            return toggleShowModal(false);
          }}
        />
      </Modal>
    </React.Fragment>
  );
};

ModalButton.defaultProps = {
  modalTitle: null,
  buttonLabel: null,
  modalProps: null,
  trigger: Button,
};

ModalButton.propTypes = {
  ...Button.propTypes,
  modalTitle: PropTypes.string,
  buttonLabel: PropTypes.string,
  modalProps: PropTypes.shape(Modal.propTypes),
  trigger: PropTypes.any,
};

export default ModalButton;
